import axios from 'axios';
import {
  CREATE_RISK_FRAMEWORK,
  LIST_RISK_MATRIX_TYPES,
  LIST_RISK_FRAMEWORKS,
  get_request_config,
  UPDATE_RISK_FRAMEWORK,

} from '@/utils/system_constants/constant.js';
import alert_mixin from '@/utils/mixins/alert_mixin';

import {
  DEFAULT_CREATE_FORM,
  DEFAULT_EDIT_FORM,
  build_create_framework_payload,
  build_edit_form,
  build_edit_framework_payload,
  current_project_id,
  filtered_frameworks,
  next_filter_mode,
  next_sort_mode,
  normalize_risk_framework,
  paginated_frameworks,
  pagination_label,
  show_bootstrap_modal,
  sort_mode_label,
  sorted_frameworks,
  total_pages,
  validate_framework_form,
} from './Create_riskframework_helper';

export default {
  name: 'CreateRiskFramework',
  mixins: [alert_mixin],
  data: () => ({
    loading: false,
    search_query: '',
    filter_mode: 'all',
    sort_mode: 'updated_desc',
    current_page: 1,
    page_size: 10,
    create_form: { ...DEFAULT_CREATE_FORM },
    risk_types: [],
    frameworks: [],

    edit_framework_id: null,

    edit_form: { ...DEFAULT_EDIT_FORM },
  }),
  computed: {
    filtered_frameworks,
    sorted_frameworks,
    paginated_frameworks,
    total_pages,
    pagination_label,
  },
  watch: {
    search_query() { this.current_page = 1; },
    filter_mode() { this.current_page = 1; },
    sort_mode() { this.current_page = 1; },
  },
  created() {
    this.fetch_risk_types();
    this.fetch_risk_frameworks();
  },
  methods: {
    current_project_id,
    normalize_risk_framework,
    fetch_risk_types() {
      axios
        .get(LIST_RISK_MATRIX_TYPES, get_request_config())
        .then(({ data }) => {
          if (data.status === 'success') {
            this.risk_types = Array.isArray(data.data) ? data.data : [];
          }
        })
        .catch((error) => {
          this.risk_types = [];
          this.show_error(
            'Error fetching risk types:',
            error?.response?.data?.message || error?.message || error,
          );
        });
    },
    fetch_risk_frameworks() {
      this.loading = true;
      const params = { project_id: this.current_project_id() };

      axios
        .get(LIST_RISK_FRAMEWORKS, get_request_config({ params }))
        .then(({ data }) => {
          if (data.status === 'success') {
            this.frameworks = Array.isArray(data.data)
              ? data.data.map((item) => this.normalize_risk_framework(item))
              : [];
          } else {
            this.frameworks = [];
            this.show_error(data?.message || 'Failed to load risk frameworks.');
          }
          
        })
        .catch((error) => {
          this.frameworks = [];
          this.show_error(
            error?.response?.data?.message || error?.response?.data?.detail || error?.message || 'Failed to load risk frameworks.',
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    format_framework_id(value) {
      return String(value || '').trim();
    },
    open_create_modal() {
      this.create_form = { ...DEFAULT_CREATE_FORM };
    },
    create_risk_framework() {
      if (!validate_framework_form(this.create_form, this.show_error)) {
        return;
      }

      const payload = build_create_framework_payload(this.create_form, this.current_project_id());

      axios
        .post(CREATE_RISK_FRAMEWORK, payload, get_request_config())
        
       .then(async ({ data }) => {
          if (data.status !== 'success') {
            this.show_error('Error creating risk framework');
            return;
          }

          this.show_success('Risk framework created successfully');
          this.close_modal('create_risk_framework_modal')

          await this.fetch_risk_frameworks();

        })
        .catch((error) => {
          this.show_error(
            error?.response?.data?.message || error?.response?.data?.detail || error?.message || 'Error creating risk framework',
          );
        });
    },
    open_edit_framework_modal(framework) {
      this.edit_framework_id = framework.id;
      this.edit_form = build_edit_form(framework);

      this.$nextTick(() => {
        show_bootstrap_modal('edit_risk_framework_modal');
      });
    },
    close_edit_modal() {
      this.close_modal('edit_risk_framework_modal');
    },
   async update_framework() {
  if (!validate_framework_form(this.edit_form, this.show_error)) {
    return;
  }

  await this.execute_framework_update();
},

async execute_framework_update() {
  const loader = await this.show_loader("Updating risk framework...");

  try {
    const response = await axios.post(
      UPDATE_RISK_FRAMEWORK,
      this.build_edit_framework_payload(),
      get_request_config()
    );

    await this.processFrameworkUpdate(response);
  } catch (error) {
    this.handle_framework_update_error(error);
  } finally {
    await this.close_loader(loader);
  }
},

handle_framework_update_error(error) {
  this.show_error(
    error?.response?.data?.message ||
    error?.response?.data?.detail ||
    "Error updating risk framework"
  );
},
    set_page(page) {
      if (page < 1 || page > this.total_pages) return;
      this.current_page = page;
    },
   
    toggle_filter_mode() {
      this.filter_mode = next_filter_mode(this.filter_mode);
    },
    cycle_sort_mode() {
      this.sort_mode = next_sort_mode(this.sort_mode);
    },
    sort_label() {
      return sort_mode_label(this.sort_mode);
    },
    async processFrameworkUpdate(response) {
      if (response.data.status !== 'success') {
        this.show_error(response.data.message);
        return;
      }

      this.show_success('Risk framework updated successfully');
      this.close_edit_modal();
      await this.fetch_risk_frameworks();
    },
    build_edit_framework_payload() {
      return build_edit_framework_payload(
        this.edit_form,
        this.edit_framework_id,
        this.current_project_id(),
      );
    },
    manage_framework(framework) {
      this.$router.push({
        name: 'RiskCategories',
        query: {
          tab: 'risk_categories',
          risk_framework_assessment_id: String(framework?.id || ''),
        },
      });
    },
  },
};
